import { delay } from 'redux-saga';
import {
  call,
  cancel,
  put,
  take,
  takeEvery,
  takeLatest,
  select,
} from 'redux-saga/effects';
import api from 'api/ApiClient';
import * as actions from './actions';
import { pushFlashMessage } from 'common/actions';
import * as c from './appConstants';
import {
  getLineItemsProcessing,
  getPendingQuantity,
  getPendingQuantitiesByLineItem,
  getLineItems,
  hasPendingCollections,
  getSidebarFocusState,
  getCartOpenState,
} from './selectors';
import { FLASH_ERROR } from 'components/shared/FlashMessages';

export const UPDATE_LINE_ITEM_QUANTITY_DELAY = 500;

export function* updateCartLineItems(
  { lineItems, isCommitting = null, canShowSuccess = true },
  apiClient = api
) {
  try {
    const pendingQuantity = yield select(getPendingQuantity);
    const order = yield call(
      apiClient.updateCartLineItems,
      lineItems,
      isCommitting
    );
    yield put(actions.saveCartSuccess(order));
    const isCollectionsPending = yield select(hasPendingCollections);
    if (isCollectionsPending) {
      yield put(actions.collectionAdded());
    }
    if (canShowSuccess) {
      yield put(actions.showAddToCartMessage(pendingQuantity));
    }
  } catch (e) {
    yield put(actions.saveCartError(e.message));
  }
}

export function* updateLineItemQuantity(
  { lineItem, quantity },
  apiClient = api
) {
  yield put(actions.changeLineItemProcessingQuantity({ lineItem, quantity }));
  yield call(delay, UPDATE_LINE_ITEM_QUANTITY_DELAY);
  const lineItems = yield select(getLineItemsProcessing);
  yield call(updateCartLineItems, { lineItems, canShowSuccess: false });
}

export function* requestOrderMembershipChange({ value }, apiClient = api) {
  try {
    const order = yield call(apiClient.changeOrderMembership, value);
    yield put(actions.saveCartSuccess(order, false));
  } catch (e) {
    yield put(actions.saveCartError(e.message));
  }
}

export function* autoClose() {
  yield call(delay, c.AUTO_CLOSE_CART_FOR_DESKTOP_DELAY);
  const isFocused = yield select(getSidebarFocusState);
  const isOpen = yield select(getCartOpenState);
  if (!isFocused && isOpen) {
    yield put(actions.toggleCartVisibility());
  }
}

export function* openCartForDesktop({ shouldAutoClose }) {
  if (window.outerWidth >= c.DESKTOP_WIDTH) {
    yield call(delay, c.OPEN_CART_FOR_DESKTOP_DELAY);
    yield put(actions.toggleCartVisibility());
    if (shouldAutoClose) {
      yield call(autoClose);
    }
  }
}

export function* wipeCart() {
  const lineItems = yield select(getLineItems);
  const lineItemsWiped = lineItems.map(lineItem => ({
    ...lineItem,
    quantity: 0,
  }));
  yield updateCartLineItems({ lineItems: lineItemsWiped });
}

export function* handleCartUpdateError({ error }) {
  yield put(pushFlashMessage(error, FLASH_ERROR));
  if (error.match(/csrf/i)) {
    yield call(delay, c.CSRF_RELOAD_TIMEOUT);
    window.location.reload();
  }
}

export default function* saga() {
  yield takeLatest(actions.SAVE_CART_REQUEST, updateCartLineItems);
  yield takeLatest(actions.CHANGE_LINE_ITEM_QUANTITY, updateLineItemQuantity);
  yield takeLatest(actions.OPEN_CART_FOR_DESKTOP, openCartForDesktop);
  yield takeLatest(actions.WIPE_CART, wipeCart);
  yield takeEvery(actions.SAVE_CART_ERROR, handleCartUpdateError);
  yield takeLatest(
    actions.CHANGE_ORDER_MEMBERSHIP,
    requestOrderMembershipChange
  );
}



// WEBPACK FOOTER //
// ./app/javascript/apps/cart/sagas.js